'use client';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { media } from '../../mixins/media.js';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper.js';

const StyledSidebarContainer = styled.div.withConfig({
  componentId: "sc-qzm6qr-0"
})(["", " overflow-y:auto;-webkit-overflow-scrolling:touch;flex-shrink:0;flex-grow:0;background:", ";"], media.greaterThan('s')`
    height: 100vh;
  `, ({
  theme
}) => theme.components.fullscreenLayout.sidebarBackgroundColor);
const StyledSidebarContentWrapper = styled(ContentWrapper).withConfig({
  componentId: "sc-qzm6qr-1"
})(["padding-top:", ";padding-bottom:", ";", " ", ""], ({
  theme
}) => theme.components.fullscreenLayout.sidebarPaddingTopMobile, ({
  theme
}) => theme.components.fullscreenLayout.sidebarPaddingBottomMobile, media.greaterThan('s')`
    padding-top: ${({
  theme
}) => theme.components.fullscreenLayout.sidebarPaddingTop};
  `, media.greaterThan('m')`
    padding-left: ${({
  theme
}) => theme.components.fullscreenLayout.sidebarPaddingHorizontal};
    padding-right: ${({
  theme
}) => theme.components.fullscreenLayout.sidebarPaddingHorizontal};
  `);
const FullscreenLayoutSidebar = ({
  children
}) => {
  return jsx(StyledSidebarContainer, {
    children: jsx(StyledSidebarContentWrapper, {
      maxWidth: 600,
      children: children
    })
  });
};

export { FullscreenLayoutSidebar };
//# sourceMappingURL=FullscreenLayoutSidebar.js.map
